import _ from 'lodash'
import {addIdToMap, getCustomId} from '../utils'
import {DATA_TYPES} from '../../../../constants/constants'
import {addNamespaceToStructure} from '../componentDeserializationStructure'
import type {DeserializeComponentParams} from '../types'

export const updateComponentRuntimeBindingsStructure = (deserializationParams: DeserializeComponentParams) => {
    const {compStructure, customId, mappers} = deserializationParams

    const runtimeBindingsData = compStructure.runtimeBindings
    if (!_.isObject(runtimeBindingsData)) {
        return
    }

    const {oldToNewIdMap} = mappers ?? {oldToNewIdMap: {}}
    deserializationParams.customId = getCustomId(oldToNewIdMap, runtimeBindingsData, customId)

    const runtimeBindingsQuery = addNamespaceToStructure(
        deserializationParams,
        runtimeBindingsData,
        DATA_TYPES.runtimeBindings,
        oldToNewIdMap
    )

    if (runtimeBindingsQuery) {
        compStructure.runtimeBindingsQuery = runtimeBindingsQuery
        addIdToMap(runtimeBindingsData, runtimeBindingsQuery, oldToNewIdMap)
    }
}
